import easelAPI from 'apis/helpers/easelAPI'
import { VisiiResponse } from 'types/Visii'

export const visiiProxyOptions = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    // Add X-Request-Source only for server calls
    ...(typeof window === 'undefined' ? { 'X-Request-Source': 'Saatchi' } : {}),
  },
}

export async function checkVisiiIdsExistApi(artworkId: string): Promise<VisiiResponse> {
  const options = { ...visiiProxyOptions }
  const json = await easelAPI.fetchJSON({
    name: 'checkVisiiIdsExistApi',
    options,
    url: `/visii/artwork-details/${artworkId}`,
  })
  return json
}

export async function fetchVisiiSimilarApi(
  artworkId: string,
  destinationZone?: string
): Promise<VisiiResponse> {
  const options = { ...visiiProxyOptions }
  const json = await easelAPI.fetchJSON({
    name: 'fetchVisiiSimilarApi',
    options,
    url: `/visii/similar/${artworkId}?destinationZone=${destinationZone}`,
  })
  return json
}

export async function fetchVisiiRecommendArtistApi(artistId: number): Promise<VisiiResponse> {
  const options = { ...visiiProxyOptions }
  const json = await easelAPI.fetchJSON({
    name: 'fetchVisiiRecommendArtistApi',
    options,
    url: `/visii/recommend?artistId=${artistId}`,
  })
  return json
}
